import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import SectionTitle from './SectionTitle/SectionTitle';

const Content = () => {
    const [title, setTitle] = useState('Writing');

    return (
        <div>
            <SectionTitle title={title} onTitleChange={setTitle} />
            <Outlet context={{ onTitleChange: setTitle }} />
        </div>
    );
};

export default Content;
